export const transformRequestDefault = (data: any) => JSON.stringify(data)
export const headersJson = {
  'Content-Type': 'application/json',
  accept: 'application/json',
}
